<template>
  <div class="program-blocks">
    <table class="table is-fullwidth">
      <thead>
        <tr>
          <th>Nazwa bloku</th>
          <th>Akcje</th>
        </tr>
      </thead>
      <transition-group name="fade" tag="tbody">
        <tr v-for="(block, index) in blocks" :key="block.id">
          <td>{{ block.name }}</td>
          <td>
            <protected :with="Permission.UPDATE_PROGRAM_BLOCK">
              <icon
                name="fa-pen"
                class="icon-control"
                @click="$emit('edit-program-block', block)"
                data-tooltip="Edytuj blok"
              />
            </protected>
            <protected :with="Permission.UPDATE_PROGRAM_BLOCK">
              <icon
                name="fa-arrow-up"
                class="icon-control"
                :class="{ 'icon-control--disabled': index <= 0 }"
                @click="moveUp(block, index)"
                data-tooltip="Przesuń do góry"
              />
            </protected>
            <protected :with="Permission.UPDATE_PROGRAM_BLOCK">
              <icon
                name="fa-arrow-down"
                class="icon-control"
                :class="{
                  'icon-control--disabled': index >= blocks.length - 1
                }"
                @click="moveDown(block, index)"
                data-tooltip="Przesuń w dół"
              />
            </protected>
            <protected :with="Permission.DELETE_PROGRAM_BLOCK">
              <icon
                name="fa-trash"
                class="icon-control is-danger"
                @click="$emit('delete-program-block', block)"
                data-tooltip="Usuń blok"
              />
            </protected>
          </td>
        </tr>
        <tr key="new-program-block">
          <td>
            <protected :with="Permission.CREATE_PROGRAM_BLOCK">
              <a @click="$emit('new-program-block')" class="new-program-block">
                <icon class="icon" name="fa-plus" />
                <span>Dodaj blok programowy</span>
              </a>
            </protected>
          </td>
          <td></td>
        </tr>
      </transition-group>
    </table>
  </div>
</template>

<script>
import { Protected } from "%mixins";
import { Icon } from "%helpers";

export default {
  name: "program-blocks",

  mixins: [Protected],

  components: {
    Icon
  },

  props: {
    blocks: Array
  },

  methods: {
    moveUp(block, index) {
      if (index > 0) {
        this.$emit("swap-program-blocks", {
          source: { id: block.id },
          target: { id: this.blocks[index - 1].id }
        });
      }
    },

    moveDown(block, index) {
      if (index < this.blocks.length - 1) {
        this.$emit("swap-program-blocks", {
          source: { id: block.id },
          target: { id: this.blocks[index + 1].id }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
tr {
  transition: 0.3s;
}

.new-program-block {
  .icon {
    margin-right: 0.5rem;
  }
}
</style>
